/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ carrier: NonNullable<unknown> }} Carrier_Notices_Delete_DescriptionInputs */

const en_carrier_notices_delete_description = /** @type {(inputs: Carrier_Notices_Delete_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This will immediately remove the checkout warning for ${i?.carrier}.`)
};

const es_carrier_notices_delete_description = /** @type {(inputs: Carrier_Notices_Delete_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esto quitara de inmediato la advertencia de checkout para ${i?.carrier}.`)
};

/**
* | output |
* | --- |
* | "This will immediately remove the checkout warning for {carrier}." |
*
* @param {Carrier_Notices_Delete_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_delete_description = /** @type {((inputs: Carrier_Notices_Delete_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Delete_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_delete_description(inputs)
	return es_carrier_notices_delete_description(inputs)
});